var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1771 16.355V23.9695H7.66525H7.56271V24.072V26.1229V26.2254H7.66525H18.9449H19.0474V26.1229V24.072V23.9695H18.9449H14.433V16.355L25.6859 4.03044L25.7127 4.00107V3.96129V1V0.897458H25.6102H1H0.897458V1V3.96129V4.00107L0.924274 4.03044L12.1771 16.355ZM3.17835 3.15339H23.4318L20.3422 6.53729H6.26797L3.17835 3.15339ZM8.32771 8.79322H18.2824L13.3202 14.228H13.2899L8.32771 8.79322Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 0.205085
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3051 17.4067L6.20076 8.17793L20.4094 8.17793L13.3051 17.4067Z",
    fill: "#FCC436"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkIcon);
export default __webpack_public_path__ + "static/media/drinkIcon.019c4012bdb4e4d6f085a9b09350bfa9.svg";
export { ForwardRef as ReactComponent };